<template>
    <div>
        <el-breadcrumb separator="/" class="bread" style="border-bottom:0;">
            <!--<el-breadcrumb-item :to="{ name: 'index' }">首页</el-breadcrumb-item>-->
            <el-breadcrumb-item style="font-size:20px;">销售交易</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 操作-->

        <!--工具条-->
        <!--<el-col :span="24" class="toolbar" style="padding: 20px 0px;text-align: left">-->
        <el-form :inline="true" :model="topForm" ref="topForm">
            <el-select v-model="topForm.branchId" placeholder="分部编号"  style="width: 13%;margin-bottom: 1%;" @change="getKisok()">
                <el-option
                        v-for="(item,index) in branchList"
                        :label="item.branchName"
                        :value="item.branchId"
                >
                </el-option>
            </el-select>
            <br/>

            <el-select v-model="topForm.kioskNo" placeholder="机器编号"  style="width: 13%;margin-right: 2%;">
                <el-option label="全部售货机" value="">全部售货机</el-option>
                <el-option
                        v-for="(item,index) in kioskList"
                        :label="item.deviceName"
                        :value="item.deviceId"
                >
                </el-option>
            </el-select>

            <el-select class="m-1" v-model="topForm.orderStatus" placeholder="交易状态" style="width: 13%;margin-right: 2%;">
                <el-option label="全部状态" value=""></el-option>
                <el-option label="正常" value="ok"></el-option>
                <el-option label="异常" value="err"></el-option>
            </el-select>

            <el-select class="m-1" v-model="topForm.orderType" placeholder="交易类型" style="width: 13%;margin-right: 2%;">
                <el-option label="全部类型" value=""></el-option>
                <el-option label="销售" value="sale"></el-option>
                <el-option label="预订" value="reserve"></el-option>
                <el-option label="领赠" value="gift"></el-option>
                <!-- <el-option label="预定提货" value="reserve"></el-option> -->
            </el-select>


            <el-input placeholder="请输入订单信息" v-model="topForm.orderId" class="input-with-select m-1" style="margin-right: 2%;width: 15%">
                <el-button slot="append" icon="el-icon-search"  style="width: auto;" @click="getOrder()"></el-button>
            </el-input>



            <el-date-picker
                    style="width: auto;margin-bottom: 1%;"
                    class="m-1"
                    v-model="topForm.datatime"
                    type="datetimerange"
                    align="right"
                    :clearable=false
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']">
            </el-date-picker><br/>


            <el-form-item style="margin-right: 5%">
                <el-button type="primary" class="m-1" @click="orderExcel()" >导出订单</el-button>
            </el-form-item>
            <el-form-item style="margin-right: 5%">
                <el-button type="primary" class="m-1" @click="orderProExcel()">导出商品订单</el-button>
            </el-form-item>
            <el-form-item style="margin-right: 5%">
                <el-button type="primary" class="" @click="getOrder()"  style="margin-right: 3%" icon="search":loading="loading">查询</el-button>
            </el-form-item>
            <el-form-item style="margin-right: 5%">
                <el-button type="primary" style="margin-right: 3%" @click="resetForm()">重置</el-button>
            </el-form-item>
        </el-form>
        <!--</el-col>-->

        <el-row>
            <el-col>
                <el-card>
                    <div slot="header" class="clearfix" shadow="hover">
                        <span>交易流水</span>
                    </div>
                    <el-table :data="orders.slice((page-1)*10,page*10)" ref="tradeTable" border row-key="orderNo" @expand-change="tradeDetail">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-table :data="orderTrans.filter(o => o.orderNo === props.row.orderNo)" >
                                    <el-table-column prop="productName" label="商品名称" width="180"></el-table-column>
                                    <el-table-column prop="SKU" label="SKU" width="100"></el-table-column>
                                    <el-table-column prop="price" label="单价">
                                        <template slot-scope="scope">
                                            ￥{{scope.row.payPrice / 100}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="price" label="支付金额">
                                        <template slot-scope="scope">
                                            ￥{{scope.row.payPrice / 100}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="商品状态">
                                        <template slot-scope="scope">
                                            <span v-if="orders[props.$index].orderStatus === 'open'" >处理中</span>
                                            <span v-if="orders[props.$index].orderStatus === 'paid'" >已支付</span>
                                            <span v-if="orders[props.$index].orderStatus === 'ok'" >正常</span>
                                            <span v-if="orders[props.$index].orderStatus === 'cancel'" >取消</span>
                                            <span v-if="orders[props.$index].orderStatus === 'bbox'" >待提货</span>
                                            <span v-if="orders[props.$index].orderStatus === 'deliver'" >取货中</span>
                                            <span v-if="orders[props.$index].orderStatus === 'err' && scope.row.outStatus == 2 " style="color:red">异常</span>
                                            <span v-if="orders[props.$index].orderStatus === 'err' && scope.row.outStatus == 1 " >正常</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="商品交易类型" width="110">
                                        <template slot-scope="scope">
                                            <span v-if="orders[props.$index].orderType === 'sale'">销售</span>
                                            <span v-else-if="orders[props.$index].orderType === 'reserve'">预订</span>
                                            <span v-else>赠品</span>
                                        </template>
                                    </el-table-column>
                                    <!--<el-table-column label="支付状态">-->
                                        <!--<template slot-scope="scope">-->
                                            <!--<span>{{ orders[props.$index].orderType === 'sale' && orders[props.$index].refundStatus == 0 ? '已支付' :'' }}</span>-->
                                            <!--<span>{{ orders[props.$index].orderType === 'sale' && orders[props.$index].refundStatus == 1 ? '需要退款' :'' }}</span>-->
                                            <!--<span>{{ orders[props.$index].orderType === 'sale' && orders[props.$index].refundStatus == -1 ? '退款失败' :'' }}</span>-->
                                            <!--<span>{{ orders[props.$index].orderType === 'sale' && orders[props.$index].refundStatus == 2 ? '已退款' : ''}}</span>-->
                                            <!--<span>{{ orders[props.$index].orderType === 'gift' ?'-':'' }}</span>-->
                                            <!--<span>{{ orders[props.$index].orderType === 'reserve' ?'第三方':'' }}</span>-->
                                        <!--</template>-->
                                    <!--</el-table-column>-->
                                    <el-table-column align="center" label="视频">
                                        <template slot-scope="scope">
                                            -
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="照片" width="110">
                                        <template slot-scope="scope">
                                            -
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="branchName"  label="分部"></el-table-column>
                        <el-table-column align="center" prop="kioskNo"  label="设备ID"></el-table-column>
                        <el-table-column align="center" prop="deviceName" label="机器名称"></el-table-column>
                        <el-table-column align="center" prop="orderNo" label="交易号" width="155px">
                            <!-- <template slot-scope="scope">
                            {{scope.row.Data.OrderNo != '' ? scope.row.Data.OrderNo : scope.row.OrderID}}</template> -->
                        </el-table-column>
                        <el-table-column align="center" prop="customerID" label="持卡人" width="155px"></el-table-column>
                        <el-table-column align="center" prop="TotalCount" label="数量" >
                            <template slot-scope="scope" >
                                <span :style="scope.row.TotalCount == scope.row.OKCount ?'':(scope.row.TotalCount > scope.row.OKCount?'color: red':'totalCount')">{{ scope.row.OKCount }}/{{ scope.row.TotalCount }}</span>
                            </template>

                        </el-table-column>
                        <el-table-column align="center" label="订单金额" >
                            <template slot-scope="scope">
                                ￥{{scope.row.subtotal / 100 }}</template>
                        </el-table-column>
                        <el-table-column align="center" label="支付金额" >
                            <template slot-scope="scope">
                                ￥{{scope.row.chargeAmount  / 100 }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="paymentMethod" label="支付方式" width="170px">
                            <template slot-scope="scope">
                                <span v-if="scope.row.paymentMethod == 'wechat' ">微信</span>
                                <span v-if="scope.row.paymentMethod == 'alipay' ">支付宝</span>
                                <span v-if="scope.row.paymentMethod == 'score:1983' ">1983积分支付</span>
                                <span v-if="scope.row.paymentMethod == 'unionPay' ">银联</span>
                            </template>
                        </el-table-column>
                        <!--<el-table-column align="center" prop="orderStatus" label="订单状态" ></el-table-column>-->
                        <el-table-column align="center" prop="createTime" label="交易时间" :formatter="formatter" width="155px"></el-table-column>
                        <el-table-column label="操作" width="155px"  align="center">
                            <template scope="scope" >
                                <el-button type="danger"  size="small" @click="goOrderInfo(scope.row)">查看详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="block" v-show="orders.length>10">
                        <el-pagination
                                layout=" total,prev, pager, next , jumper"
                                :current-page="page"
                                @current-change="table"
                                :total="orders.length">

                        </el-pagination>
                    </div>
                </el-card>
                <el-dialog title="监控/出货视频" fullscreen :visible.sync="VideoModel" @closed="videoClose()" width="70%" center>
                    <div class="video-dialog">
                        <div class="video" v-show="VideoUrl != ''">
                            <p>监控视频</p>
                            <video id = "Video" :src='VideoUrl' autoplay controls="controls"></video>
                        </div>
                        <div class="video" v-show="ExVideoUrl != ''">
                            <p>出货视频</p>
                            <video id = "VideoPath" :src='ExVideoUrl' autoplay controls="controls"></video>
                        </div>
                        <div class="video" v-show="BoxVideoUrl != ''">
                            <p>BBox视频</p>
                            <video id = "VideoBox" :src='BoxVideoUrl' autoplay controls="controls"></video>
                        </div>
                    </div>
                </el-dialog>
                <el-dialog fullscreen :visible.sync="pictureModel" width="70%" center>
                    <div class="pic-dialog">
                        <div class="boximg"><p>存入前状态</p><img :src="BoxImageUrlBD" /></div>
                        <div class="boximg"><p>存入后状态</p><img :src="BoxImageUrlAD" /></div>
                    </div>
                    <div class="pic-dialog">
                        <div class="boximg"><p>开门前状态</p><img :src="BoxImageUrlBO" /></div>
                        <div class="boximg"><p>关门后状态</p><img :src="BoxImageUrlAC" /></div>
                    </div>
                </el-dialog>
            </el-col>
        </el-row>

    </div>



</template>
<script>
    /*import  Bootpage from "../page/Bootpage.vue"*/
    import moment  from 'moment';
    import tableOrder from './table.vue';
    import ElDialog from "../../../../node_modules/element-ui/packages/dialog/src/component.vue";
    import ElCol from "element-ui/packages/col/src/col";
    export  default{
        components: {
            ElCol,
            ElDialog,'table-order':tableOrder
        },
        data(){
            return {
                /*弹窗选择*/
                loading:false,
                kioskList:[],
                branchList:[],
                orders: [],
                orderTrans: [],
                /*弹窗内容选择*/
                topForm:{
                    orderId:'',
                    branchId:'',
                    branchName:'',
                    kioskNo:'',
                    orderStatus:'',
                    orderType:'',
                    datatime:[new Date(new Date(new Date().toLocaleDateString()).getTime() - 6 * 24 * 60 * 60 * 1000), new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)],
                },
                page: 1,
                transaction: [],
                videoBtnFlg: 0,
                VideoModel: false,
                pictureModel: false,
                VideoUrl: '',
                ExVideoUrl: '',
                BoxVideoUrl: '',
                BoxImageUrlAC: 'https://via.placeholder.com/400x300.png?text=not%20found',
                BoxImageUrlAD: 'https://via.placeholder.com/400x300.png?text=not%20found',
                BoxImageUrlBD: 'https://via.placeholder.com/400x300.png?text=not%20found',
                BoxImageUrlBO: 'https://via.placeholder.com/400x300.png?text=not%20found',
                callCancel:null,
            }

        },
        created(){

            if(this.$route.query.kioskNo != null && this.$route.query.kioskNo != undefined){
                this.topForm.branchId = this.$route.query.branchNo;
                this.topForm.kioskNo = this.$route.query.kioskNo;
                this.topForm.orderStatus = this.$route.query.orderStatus;
                this.topForm.orderType = this.$route.query.orderType;
                this.topForm.orderId = this.$route.query.orderId;
                this.topForm.datatime = [new Date(this.$route.query.startTime),
                    new Date(this.$route.query.endTime)];
            }


            this.getBranchList();
        },
        methods: {
            table(val) {
                this.page = val;
            },
            getOrder: function (lastID, silent) {
                var params = {tenantId:this.getcookie('storeId'),branchNo:this.topForm.branchId,kioskNo:this.topForm.kioskNo,
                    orderStatus:this.topForm.orderStatus,orderType:this.topForm.orderType,orderId:this.topForm.orderId,
                    startTime:parseInt(this.topForm.datatime[0].getTime()/1000),endTime:parseInt(this.topForm.datatime[1].getTime()/1000)
                };
                //异步请求
                this.$http.get(this.productURL+"/vueFeign/findOfflineOrder",{params:params})
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                this.orders = [];
                                console.log('getOrder',response)
                                var li = response.body.Data ? response.body.Data : [];
                                for (var i = 0; i < li.length; i++) {
                                    this.orders.push(li[i]);
                                }
                                console.log(this.orders);

                            }else{
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                            }
                        }
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            orderTransaction: function (orderID) {
                var params = {orderNo:orderID};
                //异步请求
                this.$http.get(this.productURL+"/vueFeign/findOrderProList",{params:params})
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                console.log('orderTrans',response.body.Data)
                                var li = response.body.Data ? response.body.Data : [];
                                for (var i = 0; i < li.length; i++) {
                                    this.orderTrans.push(li[i]);
                                }
                                console.log(this.orderTrans);

                            }else{
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                            }
                        }
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            tradeDetail: function (order, expandedRows) {
                console.log('orderorder',order)
                console.log('this.orderTrans',this.orderTrans)
                if (this.orderTrans.findIndex(o => o.orderNo == order.orderNo ) < 0) {
                    console.log(this.orderTrans.findIndex(o => o.orderNo === order.orderNo ))
                    this.orderTransaction(order.orderNo)
                }
            },
            videoClose: function() {
                this.ExVideoUrl = ''
                this.VideoUrl = ''
                this.BoxVideoUrl = ''
            },
            getBranchList(){
                this.$http.get(this.deviceHost+"/vueFeign/findBranchs?tenantId="+this.getcookie('storeId')+"&Token="+this.token)
                    .then(response => {
                        if (response.body.Code === '200') {
                            this.branchList = response.body.Data.branchs;
                            if(this.topForm.branchId == '' || this.topForm.branchId == null){
                                this.topForm.branchId = response.body.Data.branchs[0].branchId;
                                this.topForm.branchName = response.body.Data.branchs[0].branchName;
                            }
                            this.getOrder();
                            this.getKisok();
                        }
                    }, function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });

                    })
            },
            formatter(row, column) {
                var d = new Date(row.createTime.time);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },
            goOrderInfo(row){
                this.savecookie("button", "orderInfo");
                this.$router.push( {path:"orderInfo",query:{row:row,go:'button',branchNo:this.topForm.branchId,kioskNo:this.topForm.kioskNo,
                    orderStatus:this.topForm.orderStatus,orderType:this.topForm.orderType,orderId:this.topForm.orderId,
                    startTime:this.topForm.datatime[0].getTime(),endTime:this.topForm.datatime[1].getTime()}});
            },
            getKisok(){
                this.$http.get(this.deviceHost+"/vueFeign/findDeviceList?tenantId="+this.getcookie('storeId')+"&branchId="+this.topForm.branchId+"&Token="+this.token)
                    .then(response => {
                        if (response.body.Code === '200') {
                            if(response.body.Data != null){
                                this.kioskList = response.body.Data;
                            }
                        }
                    }, function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });

                    })
            },
            resetForm(){
                this.topForm.kioskNo = '';
                this.topForm.orderId = '';
                this.topForm.orderStatus = '';
                this.topForm.orderType = '';
                this.getOrder();
            },
            orderExcel(){
                var params = {tenantId:this.getcookie('storeId'),branchId:this.topForm.branchId};
                //异步请求
                this.$http.post(this.productURL+"/vueFeign/orderExcl",params)
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                var orders = response.body.Data
                                if(orders.length > 0){
                                    var name = response.body.Data[0].branchName
                                    var d = new Date();
                                    var formatString = formatString || 'YYMMDD';
                                    var time =  moment(d).format(formatString);
                                    //excel数据导出
                                    require.ensure([], () => {
                                        const {
                                            export_json_to_excel
                                        } = require('../../../assets/js/Export2Excel');
                                        const tHeader = ['分组名称','机器编号', '机器名称','交易号','SKU','商品名称','失败数量','成功数量','订单金额','优惠额','支付金额','退款金额','退款状态','交易时间','支付方式','持卡人','优惠码','提货码'];
                                        const filterVal = ['branchName','kioskNo', 'deviceName', 'orderNo','SKU','productName','errNum','okNum','subtotal','discount','chargeAmount','refundAmount','refStatus','createTime','paymentMethod','customerID','deliveryID','deliveryCode'];
                                        const list = orders;
                                        const data = this.formatJson(filterVal, list);
                                        export_json_to_excel(tHeader, data, '19八3_'+name+'_订单交易_'+time+'_'+new Date().getTime());
                                    })
                                }else {
                                    this.$message({ showClose: true, message: "暂无数据",  type: 'error' });
                                }

                            }else{
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                            }
                        }
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            orderProExcel(){
                var params = {tenantId:this.getcookie('storeId'),branchId:this.topForm.branchId};
                //异步请求
                this.$http.post(this.productURL+"/vueFeign/orderProExcel",params)
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                var orders = response.body.Data
                                if(orders.length > 0){
                                    var name = response.body.Data[0].branchName
                                    var d = new Date();
                                    var formatString = formatString || 'YYMMDD';
                                    var time =  moment(d).format(formatString);
                                    require.ensure([], () => {
                                        const {
                                            export_json_to_excel
                                        } = require('../../../assets/js/Export2Excel');
                                        const tHeader = ['分组名称','机器编号', '机器名称','交易号','SKU','UPC','商品名称','售价','优惠','支付金额','退款金额','退款状态','交易状态','交易类型','支付方式','持卡人','交易时间','优惠码','提货码'];
                                        const filterVal = ['branchName','kioskNo', 'deviceName', 'orderNo','SKU','UPC','productName','price','discount','payPrice','refPrice','refStatus','outStatus','orderType','paymentMethod','customerID','createTime','deliveryID','deliveryCode'];
                                        const list = orders;
                                        const data = this.formatJson(filterVal, list);
                                        export_json_to_excel(tHeader, data, '19八3_'+name+'_商品交易_'+time+'_'+new Date().getTime());
                                    })
                                }else {
                                    this.$message({ showClose: true, message: "暂无数据",  type: 'error' });
                                }
                            }else{
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                            }
                        }
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            }
        }

    }

</script>
<style>
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .customWidth {
        width: 60%;
    }
    .box_relative{
        float: left;
    }
</style>


// WEBPACK FOOTER //
// trade.vue?208cefa2